import { Link } from "react-router-dom";
import "./carddocumentlist.scss";
import { ICardResponse } from "../../../core/models";

export interface ICardDocumentProps {
  title?: string;
  index?: number;
  props?: ICardResponse;
}

const CardDocumentList = ({ index, title, props }: ICardDocumentProps) => {
  const pushEventForCardClick = () => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Bülten Tıklama",
          eventSegment: {
            bultenAdi: props?.title,
            yol: title,
            siralama: (index ?? 0) + 1,
          },
          actionType: "event",
        })
      );
    }
  };

  return (
    <Link
      to={{
        pathname: props?.detailUrl,
      }}
      className="document-item"
      onClick={pushEventForCardClick}
    >
      <div className="document-item__image">
        <img
          src={"/icons/pdf-secondary.svg"}
          width={32}
          height={32}
          alt={props?.listImage?.alt}
          style={{ height: "auto", width: "32px" }}
        />
      </div>
      <div className="document-item__text">
        <span className="title">
          <strong>{props?.title}</strong>
        </span>
        <div className="date-container">
          <span className="date">{props?.dateAreaFormatted}</span>
          <span className="time ">{props?.readTime}</span>
          <img src={"/icons/clock.svg"} width={16} height={16} alt="clock" />
        </div>
        <span className="icon icon-arrow-right"></span>
      </div>
    </Link>
  );
};

export default CardDocumentList;
